import styled from 'styled-components'

export const InfoValue = styled.span`
  font-weight: 800;
  color: ${({ theme }) => theme.colors.text};
  font-size: 14px;
`
